import service from '@/utils/request';

// 获取wx sdk 需要的配置
export function getInitWxSdkInfo(data, customConf = { hideErrInfo: false, noCheckRepeat: true }) {
    return service.post('/infc/wx/getWXSign', data, { custom: customConf });
}
